/**
 * =============================================================================
 * LAS CINCO AREAS CLINICAS — COPIA DEL PORTAL
 * =============================================================================
 * A diferencia del foco clinico —que vive en la coleccion `therapycategories` y
 * por eso NO se copia nunca al frontend, ver `focoClinico.js`— las areas son un
 * `enum` CERRADO en el modelo de Mongoose. No crecen solas: anadir una es tocar
 * codigo del servidor. Por eso aqui si se pueden listar.
 *
 * OJO CON "Fisica": lleva i con tilde y va escrita por su codigo (U+00ED) a
 * proposito.
 *
 * El `enum` de Mongoose compara BYTES. Si esta cadena se escribe sin tilde
 * —copiando de un sitio donde el encoding se vio mal, que en este proyecto pasa
 * a diario— el guardado falla con un mensaje de validacion que no menciona la
 * tilde por ningun lado, y nadie relaciona una cosa con la otra.
 *
 * `areasClinicas.portal.test.js`, en el servidor, compara esta lista con
 * `CLINICAL_AREAS` elemento a elemento y falla si se separan.
 * =============================================================================
 */

export const CLINICAL_AREAS = Object.freeze([
  "Cognitiva",
  "F\u00EDsica",
  "Emocional",
  "Funcional",
  "General",
]);

export const DEFAULT_CLINICAL_AREA = "General";
